<template>
    <svg
        viewBox="0 0 102 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="102"
        height="17"
        class="group relative z-30 h-[2.75rem] w-auto lg:h-[3.75rem] xl:h-[4.75rem]">
        <path
            d="M15.8807 0.519287H0V3.71881H15.8807V0.519287Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M15.8807 0.519287H0V3.71881H15.8807V0.519287Z"
            fill="#FCB53B"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M15.8807 6.91821H0V10.1178H15.8807V6.91821Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M15.8807 6.91821H0V10.1178H15.8807V6.91821Z"
            fill="#F57F29"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M15.8807 13.3171H0V16.5167H15.8807V13.3171Z"
            fill="white"
            class="transition-opacity duration-300 group-hover:opacity-0" />
        <path
            d="M15.8807 13.3171H0V16.5167H15.8807V13.3171Z"
            fill="#E32213"
            class="opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <path
            d="M77.5925 3.72224L80.101 10.1151H75.0769L77.5925 3.72224ZM75.1589 0.521484L69.0625 16.5192H72.7034L73.8957 13.3125L81.2896 13.3156L82.4817 16.5192H86.1031L79.6523 0.521484H75.1589Z"
            fill="white" />
        <path
            d="M22.2305 0.521484V16.5192H35.2597V13.3217L25.4155 13.3161V10.1185H35.2597V6.91281H25.4155V3.72336L35.2597 3.71264V0.521484H22.2305Z"
            fill="white" />
        <path
            d="M88.3047 16.5065H94.4622H96.9061C99.4708 16.5065 101.644 14.7501 101.644 11.7581C101.644 10.5249 101.174 9.31492 99.7083 8.51404C101.405 7.51951 101.644 6.50311 101.644 5.26998C101.644 2.66728 99.4709 0.521484 96.9062 0.521484H94.4623H88.3047V3.77493H96.7583C97.621 3.77493 98.3204 4.47949 98.3204 5.34864C98.3204 6.21779 97.621 6.92241 96.7583 6.92241H95.0704H89.8884V10.1056H95.0704H96.7583C97.621 10.1056 98.3204 10.8102 98.3204 11.6793C98.3204 12.5485 97.621 13.2531 96.7583 13.2531H88.3047L88.3047 16.5065Z"
            fill="white" />
        <path
            d="M64.6724 0.521484H62.2285H55.9121V16.5192H59.0899V10.1056H62.8366H64.6724C67.2997 10.1056 69.4294 7.96008 69.4294 5.3135C69.4294 2.66691 67.2997 0.521484 64.6724 0.521484ZM64.5245 6.92241H59.0855V3.77493H64.5245C65.3872 3.77493 66.0867 4.47949 66.0867 5.34864C66.0867 6.21779 65.3872 6.92241 64.5245 6.92241Z"
            fill="white" />
        <path
            d="M50.5691 8.51398C52.2656 7.51945 52.5043 6.50311 52.5043 5.26998C52.5043 2.66728 50.3316 0.521484 47.7669 0.521484L47.767 0.521538C47.7662 0.521538 47.7656 0.521484 47.7649 0.521484H39.084V16.5065H47.9237C50.4885 16.5065 52.6612 14.7501 52.6612 11.758C52.6613 10.5249 52.0346 9.31502 50.5691 8.51398ZM42.2574 3.77498H47.6169C48.4797 3.77498 49.1791 4.47955 49.1791 5.34869C49.1791 6.21784 48.4797 6.92246 47.6169 6.92246H46.0085H42.2574V3.77498ZM47.7758 13.2531H42.2574V10.1056H47.7758C48.6386 10.1056 49.3379 10.8102 49.3379 11.6793C49.3379 12.5485 48.6386 13.2531 47.7758 13.2531Z"
            fill="white" />
    </svg>
</template>
<script setup lang="ts"></script>
